import {ENDPOINT_ADMIN_DEPS_STATUSES_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const {
  apiRequestAdmin,
} = require('../ws');

const MOCK_DEPOSITS_STATUS = loopMap(100, (i) => {
  const id = '' + (1 + i);
  return {
    id: '24286723-46435-43545-3454423-2343' + id,
    login: 'String _ ' + id,
    sc_additions: 13.32402,
    sc_amount: 13.32402,
    collect_sc_amount: 13.32402,
    collect_cc_amount: 13.32402,
    status: 'ready',
  };
});

export function apiAdminDepositsStatusList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      list: MOCK_DEPOSITS_STATUS.slice(offset, offset + limit),
      count: MOCK_DEPOSITS_STATUS.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_DEPS_STATUSES_LIST, {
    ...params,
    offset,
    limit,
  });
}
